import { render, staticRenderFns } from "./ChannelWorkspace.vue?vue&type=template&id=d947938a&scoped=true"
import script from "./ChannelWorkspace.vue?vue&type=script&lang=ts"
export * from "./ChannelWorkspace.vue?vue&type=script&lang=ts"
import style0 from "./ChannelWorkspace.vue?vue&type=style&index=0&id=d947938a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d947938a",
  null
  
)

export default component.exports